import * as actions from './actionsTypes';

const initialData = {
  loaderDashboardVacantes: false,
  dashboardSelectDataVacantes: {},
  dashboardErrorVacantes: ''
}

export default function DashBoardSelectVacantesReducer(state = initialData, action){
    
  switch (action.type) {
    case actions.LOADING_DASHBOARD_SELECT_RESPONSIBLE_VACANTES:
      return {...state, loaderDashboardVacantes: action.payload}
    case actions.GET_DASHBOARD_SELECT_RESPONSIBLE_VACANTES:
      return {...state, dashboardSelectDataVacantes: action.payload}
    case actions.DASHBOARD_SELECT_ERROR_VACANTES:
      return {...state, dashboardErrorVacantes: action.payload}
    default:
      return state
  }
}